export default {
    SELECT_OBJECT: "Выберите один или несколько объектов документа",
    NO_AVAILABLE_METHODS: "Нет доступных для вызова методов"
};
